





























































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { accountEdit } from '@/api/admin'
import { MapType } from '@/util/types'

@Component
export default class AccountForm extends ViewBase {
  @Prop({ type: Object, default: () => ({}) }) item!: object
  @Prop({ type: Boolean, default: true }) visible!: boolean
  @Prop({ type: Array, default: () => [] }) subjectList!: object[]
  @Prop({ type: Array, default: () => [] }) phaseList!: object[]
  labelCol = { span: 24 }
  wrapperCol = { span: 24 }
  lang = {}
  sitem = {}
  isEdit = false
  school = ''
  form = {}
  ssubjectList = []
  editPsw = false
  doc: any
  confirmDirty: boolean = false
  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  created() {
    this.doc = window.document
    this.school = JSON.parse(localStorage.school).school_key
    this.lang = this.i18n.vAccountForm
    this.form = this.$form.createForm(this)
    const lang: any = this.lang
  }

  @Watch('visible')
  watchVisible(visible: any) {
    if (visible) {
      const item: any = Object.assign({}, this.item)
      const subjectList: any = Object.assign({}, this.subjectList)

      this.isEdit = item.id > 0
      this.sitem = item
      this.ssubjectList = subjectList
    }
  }
  @Watch('item')
  watchItem(item: any) {
    const item2: any = Object.assign({}, item)
    this.isEdit = item2.id > 0
    this.sitem = item2
    // this.sitem = this.item
    // console.log(this.item, this.subjectList, this.phaseList)
  }
  // onOk() {
  //   this.hide()
  // }
  onCancel() {
    this.hide()
  }

  handleConfirmBlur(e: any) {
    const value = e.target.value
    this.confirmDirty = this.confirmDirty || !!value
  }

  onPwdValidator(rule: any[], value: string, callback: any) {
    const form: any = this.form
    if (value && this.confirmDirty) {
      form.validateFields(['repwd'], { force: true })
    }
    callback()
  }
  onRepwdValidator(rule: any, value: any, callback: any) {
    const form: any = this.form
    if (value && value !== form.getFieldValue('password')) {
      callback(new Error(this.i18n.vAccountForm.checkPassword))
    } else {
      callback()
    }
  }
  changegephase(val: any) {
    // console.log(val)
    const form: any = this.form
    const phaseListxxx = this.phaseList
    let subject: any = []
    phaseListxxx.forEach((ele: any) => {
      if (ele.id == val) {
        subject = ele.subject
      }
    })
    form.setFieldsValue({
      subject_id: ''
    })
    this.ssubjectList = subject
  }
  changegesubject(val: any) {}

  hide() {
    const form: any = this.form
    form.resetFields()
    this.$emit('hideform')
  }
  changePsw(val: any) {
    if (val.currentTarget.value.length > 5) {
      this.editPsw = true
    } else {
      this.editPsw = false
    }
  }
  handleSubmit(e: any) {
    e.preventDefault()
    // console.log('tijiao')
    const form: any = this.form
    const item: any = this.item
    form.validateFieldsAndScroll((err: any, vals: any) => {
      if (!err) {
        // console.log('Received values of form: ', vals)

        const pdata = {
          id: item.id || '',
          username: vals.username,
          nickname: vals.nickname,
          password: vals.password || '',
          subject_id: vals.subject_id,
          phase_id: vals.phase_id
        }
        this.onOk(pdata)
      }
    })
  }
  async onOk(pdata: any) {
    try {
      const res = await accountEdit(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      const form: any = this.form
      form.resetFields()
      this.$emit('onDone')
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
